<template>
  <div class="main-container">
  
    <end_info></end_info>
    <h2>Congratulations!</h2> 
    <h4>You have successfully claimed your prize. A represtenative will follow up with more information regarding your prize.</h4>
    <br><br><hr>
    <h2>Thank You for Playing!</h2>
    <subscribe_form  v-if="local_config.fields.phone != undefined || local_config.fields.email_optin != undefined"></subscribe_form>

  </div>
</template>

<script>
    import {form_methods,requests_methods, validation} from "../mixins/requests";
    import {elements_classes} from '../mixins/elements_classes'

    import Social_share from '../components/Social_share'
    import Subscribe_form from '../components/Subscribe_form'
    import End_info from '../components/End_info'

    export default {
        name: "fulfillment_success",
        mixins: [form_methods,requests_methods, validation, elements_classes],
        components: {
            'social_share': Social_share,
            'subscribe_form': Subscribe_form,
            'end_info': End_info,
        },
        data(){
            return{
                // this_page: 'success'
            }
        },
        computed: {
            this_page(){
                return this.$route.name
            }

        }
    }
</script>

<style scoped>
</style>